import { COLOR_GREEN_BASE } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSize, getCircleMarkerSizeWithoutShadow } from './svgMarkerComponents';

const innerDiameter = 16;
export const size = getCircleMarkerSize(innerDiameter);
export const svgSizeWithoutShadow = getCircleMarkerSizeWithoutShadow(innerDiameter);
const startSvg = createCircleMarker({ imageName: 'start', innerDiameter, innerFill: COLOR_GREEN_BASE });

export default startSvg;
